import { APP_NAME, APP_TAGLINE } from '@fade/shared';

import { useSession } from '../lib/auth';

export function HomePage() {
  const { data: session, isPending } = useSession();

  return (
    <main className="mx-auto flex min-h-full max-w-3xl flex-col items-center justify-center px-6 py-16">
      <h1 className="font-serif text-5xl font-light tracking-tight">{APP_NAME}</h1>
      <p className="mt-4 text-center text-lg text-muted-foreground">{APP_TAGLINE}</p>

      <nav className="mt-12 flex flex-wrap items-center justify-center gap-3 text-sm">
        <a className="rounded-md border px-4 py-2" href="/feed">
          Read the feed
        </a>
        <a className="rounded-md border px-4 py-2" href="/random">
          A random story
        </a>
        {isPending ? null : session ? (
          <>
            <a className="rounded-md bg-primary px-4 py-2 text-primary-foreground" href="/profile">
              My Profile
            </a>
            <a className="rounded-md border px-4 py-2" href="/legacies/new">
              Write a story
            </a>
            <button
              type="button"
              className="rounded-md border px-4 py-2"
              onClick={async () => {
                await fetch('/api/auth/sign-out', {
                  method: 'POST',
                  credentials: 'include',
                  headers: { 'content-type': 'application/json' },
                  body: JSON.stringify({}),
                });
                window.location.href = '/';
              }}
            >
              Sign out
            </button>
          </>
        ) : (
          <>
            <a className="rounded-md bg-primary px-4 py-2 text-primary-foreground" href="/sign-in">
              Sign in
            </a>
            <a className="rounded-md border px-4 py-2" href="/sign-up">
              Create an account
            </a>
          </>
        )}
      </nav>
    </main>
  );
}